__turbopack_context__.v({
  "chatThread": "ChatThread-module__xSj-0q__chatThread",
  "chatThreadItem__Participants": "ChatThread-module__xSj-0q__chatThreadItem__Participants",
  "chatThread__Separator__avatars": "ChatThread-module__xSj-0q__chatThread__Separator__avatars",
  "chatThread__Separator__extraAvatar": "ChatThread-module__xSj-0q__chatThread__Separator__extraAvatar",
  "chatThread__activate": "ChatThread-module__xSj-0q__chatThread__activate",
  "chatThread__replies": "ChatThread-module__xSj-0q__chatThread__replies",
});
